import { useQuery } from 'hooks/useQuery'

import { fetchUser } from 'utils/queries'

import { UserType } from 'types/user'

export const useUser = ({ userId = '', username = '' }) => {
  const userQuery = useQuery<UserType | null>(
    ['user', userId, username],
    () => fetchUser({ userId, username }),
    {
      // The query will not execute until userId or username exists
      enabled: (!!userId || !!username) && !(userId && username),
    },
  )

  return userQuery
}
